import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  loginPageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f3f7f7',
  },

  loginPageContent: {
    backgroundColor: theme.palette.background.white,
    display: 'flex',
    width: '92%',
    margin: (props) => (props.aboveTabScreenSize ? '0px' : '4px 4px 0px 0px'),
    minHeight: (props) => props?.zoomOut && '95%',
    height: (props) => !props?.zoomOut && '95%',
    '@media only screen and (min-width:600px) and (min-height: 550px)': {
      width: '80%',
      height: '70% !important',
    },
  },

  loginPageTextContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    padding: '10%',
    color: '#262A4C',
    '@media only screen and (min-width:600px) and (min-height: 500px)': {
      order: 1,
      padding: '5%',
      width: '50%',
    },
  },

  signInTitle: {
    fontSize: '26px',
    fontWeight: 700,
    '@media only screen and (min-width:600px) and (min-height: 500px)': {
      fontSize: '28px',
    },
    '@media only screen and (min-width:1440px)': {
      fontSize: '30px',
    },
    '@media only screen and (min-width:2560px)': {
      fontSize: '40px',
    },
  },

  signInContent: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1.3',
    marginTop: 20,
    marginBottom: 30,
    '@media only screen and (min-width:600px) and (min-height: 500px)': {
      fontSize: '18px',
    },
    '@media only screen and (min-width:1440px)': {
      fontSize: '20px',
    },
    '@media only screen and (min-width:2560px)': {
      fontSize: '30px',
    },
  },

  centerLoader: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: '193px',
  },

  loginLogoContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '50%',
    padding: '5% 5% 0% 5%',
    '@media only screen and (min-width:600px) and (min-height: 500px)': {
      width: '50%',
      height: '100%',
      order: 2,
      padding: '5% 5% 5% 0%',
    },
  },

  loginButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    alignItems: 'center',
    marginTop: '1.5rem',
  },

  microsoftButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    width: '240px',
    height: '40px',
    backgroundColor: '#fff',
    border: '1px solid #dadce0',
    borderRadius: '4px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    fontFamily: 'Roboto, Arial, sans-serif',
    fontSize: '14px',
    color: '#3c4043',
    transition: 'background-color 0.2s, box-shadow 0.2s',
    '&:hover': {
      backgroundColor: '#f7f8f8',
      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
    },
  },

  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '1rem',
  },
}))

export { useStyles }
